import { TFunction } from 'src/constants/i18next';
import { TSelectItem } from '../components/types';
import {
    BOTH_DIGITAL_CARTYPE,
    NEW_CARTYPE,
    PREOWNED_CARTYPE,
    TUserCarType,
} from 'src/constants/user';

/**
 * Maps the car types to a select item
 *
 * @param {TUserCarType} carType
 * @param {TFunction} t
 * @return {*}  {TSelectItem[]}
 */
export const mapCarTypes = (
    carType: TUserCarType,
    t: TFunction
): TSelectItem[] => {
    if (carType === NEW_CARTYPE) {
        return [
            {
                label: t('AdvancedAll.CarTypes'),
                value: '',
            },
            {
                label: t('Leads.New'),
                value: 'nuevo',
            },
        ];
    }
    if (carType === PREOWNED_CARTYPE) {
        return [
            {
                label: t('AdvancedAll.CarTypes'),
                value: '',
            },
            {
                label: t('Leads.Preowned'),
                value: 'seminuevo',
            },
        ];
    }
    if (carType === BOTH_DIGITAL_CARTYPE) {
        return [
            {
                label: t('AdvancedAll.CarTypes'),
                value: '',
            },
            {
                label: t('Leads.New'),
                value: 'nuevo',
            },
            {
                label: t('Leads.Preowned'),
                value: 'seminuevo',
            },
        ];
    }
    return [];
};
